<template>
  <div>
  </div>
</template>

<script>
    export default {
        name: "Auth",
        created() {
            // 获取参数 appid --- 正式
            const appid = this.$route.query.appid;
            if(appid){
                window.localStorage.setItem("fastappid",appid);
            }
            // 微信回调页面   --- 正式
            window.location.href =
                'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+ window.localStorage.getItem("fastappid") +
                '&redirect_uri=http%3A%2F%2Fbcss.gongniu.cn%2Ffast%2Findexpage' +
                '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';

            // 测试时设定
            // window.localStorage.setItem("fastappid","wxa9f5dd8a96e17e12");
            // window.location.href = 'http://127.0.0.1:8888/indexpage?code='+ window.localStorage.getItem("fastappid");
            // window.location.href = 'http://127.0.0.1:8080/fast/index?code=12315646';
        }
    }
</script>

<style scoped>

</style>
